const WFacbook = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 9.90181C0 14.3763 3.24975 18.0971 7.5 18.8516V12.3513H5.25V9.85156H7.5V7.85131C7.5 5.60131 8.94975 4.35181 11.0002 4.35181C11.6497 4.35181 12.3503 4.45156 12.9998 4.55131V6.85156H11.85C10.7498 6.85156 10.5 7.40131 10.5 8.10181V9.85156H12.9L12.5002 12.3513H10.5V18.8516C14.7502 18.0971 18 14.3771 18 9.90181C18 4.92406 13.95 0.851562 9 0.851562C4.05 0.851562 0 4.92406 0 9.90181Z"
        fill="white"
      />
    </svg>
  );
};

export default WFacbook;
